import { render, staticRenderFns } from "./NumberOfVisitsMT.vue?vue&type=template&id=958fac2e&scoped=true&"
import script from "./NumberOfVisitsMT.vue?vue&type=script&lang=js&"
export * from "./NumberOfVisitsMT.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfVisitsMT.vue?vue&type=style&index=0&id=958fac2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958fac2e",
  null
  
)

export default component.exports